import { LoadMask, useToasts } from '@vestaboard/installables'
import React, { useState } from 'react'
import { csvDownload, csvFormat } from '../utils'

import { ApolloConsumer } from '@apollo/react-common'
import { Button } from '@material-ui/core'
import { DocumentNode } from 'graphql'
import { GetApp } from '@material-ui/icons'

interface ICsvExportCursorBased {
  query: DocumentNode
  getVariables: (cursor?: string | null) => any
  formatData: (data: any) => any[]
  getCursor: (data: any) => string | null
}

export const CsvExportCursorBased = (props: ICsvExportCursorBased) => {
  const [loading, setLoading] = useState(false)
  const { addToast } = useToasts()

  return (
    <ApolloConsumer>
      {apollo => {
        const buildPaginationPage = async (prev: any[], cursor?: string | null): Promise<any[]> => {
          try {
            const result = await apollo.query({
              fetchPolicy: 'network-only',
              query: props.query,
              variables: props.getVariables(cursor || null)
            })
            const current = props.formatData(result)
            const data = [...prev, ...current]
            const nextCursor = props.getCursor(result)
            if (!nextCursor) {
              return data
            }
            return await buildPaginationPage(data, nextCursor)
          } catch (e) {
            addToast(`Error exporting CSV`, {
              appearance: 'error'
            })
            return prev
          }
        }

        return (
          <>
            {loading ? <LoadMask /> : null}
            <Button
              endIcon={<GetApp />}
              variant='outlined'
              onClick={async () => {
                setLoading(true)
                const result = await buildPaginationPage([], null)
                const csv = csvFormat(result, Object.keys(result[0]))
                setLoading(false)
                csvDownload(csv)
              }}>
              Export CSV
            </Button>
          </>
        )
      }}
    </ApolloConsumer>
  )
}
